import type { ReactNode } from 'react'
import Drawer from '@/features/cbam-reporting/components/Drawer'

export type CbamGoodDetailsDrawerLayoutProps = {
  isOpen: boolean
  close: () => void
  /** Typically an `H2` plus translated title. */
  title: ReactNode
  /** Optional row below the title (e.g. eligibility badge). */
  headerAccessory?: ReactNode
  children: ReactNode
}

export default function CbamGoodDetailsDrawerLayout({
  isOpen,
  close,
  title,
  headerAccessory,
  children
}: CbamGoodDetailsDrawerLayoutProps) {
  return (
    <Drawer isOpen={isOpen} close={close}>
      <div className="flex flex-col h-full">
        <div className="shrink-0 p-4 border-b">
          <div className="flex items-center justify-between mb-4">
            {title}
            <button
              type="button"
              onClick={close}
              className="bg-green-500 text-white h-8 w-8 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors text-xl leading-none"
            >
              &times;
            </button>
          </div>
          {headerAccessory ? (
            <div className="flex items-center gap-2">{headerAccessory}</div>
          ) : null}
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">{children}</div>
      </div>
    </Drawer>
  )
}
